<script setup lang="ts">
import Logo from "@/assets/icons/logo.svg?component";

const localeRoute = useLocaleRoute();
</script>

<template>
  <header class="z-50 w-full border-b border-app-border bg-white">
    <div
      class="mx-auto flex h-[72px] w-full max-w-[1280px] items-center justify-between gap-4 px-4"
    >
      <NuxtLink
        :to="localeRoute('/')"
        class="flex min-w-0 cursor-pointer items-center gap-0.5 text-primary"
      >
        <Logo class="h-10 w-8 shrink-0" />

        <span
          class="hidden select-none whitespace-nowrap font-gabarito text-2xl font-bold uppercase leading-none tracking-[-0.02em] text-primary md:block"
        >
          Senta.lt
        </span>
      </NuxtLink>

      <HeaderActions />
    </div>
  </header>
</template>
